export interface IAppConfig {
  defaultTime: number;
}

export const appConfig: IAppConfig = {
  defaultTime: 20000
};
